import { render, staticRenderFns } from "./visualEditor.vue?vue&type=template&id=ba15ba0c"
import script from "./visualEditor.vue?vue&type=script&lang=js"
export * from "./visualEditor.vue?vue&type=script&lang=js"
import style0 from "./visualEditor.vue?vue&type=style&index=0&id=ba15ba0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports